import { useEffect, useRef } from 'react';
import '../../styles/Busquedas/hiring.scss';

const HALAXIA_EMBED_SRC =
  'https://www.halaxia.com/empleos/serendipia-consultora?iframe_mode=true&register_success=https://www.halaxia.com/empresa/serendipia-consultora';

export const Hiring = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleMessage = (e: MessageEvent) => {
      const hxSetHeight = (e.data as { hxSetHeight?: number } | undefined)
        ?.hxSetHeight;
      if (
        hxSetHeight != null &&
        typeof hxSetHeight === 'number' &&
        iframeRef.current
      ) {
        iframeRef.current.height = `${hxSetHeight + 75}`;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="hiring">
      <iframe
        ref={iframeRef}
        id="hx-iframe"
        title="Empleos — Serendipia Consultora (Halaxia)"
        width="100%"
        height={2900}
        src={HALAXIA_EMBED_SRC}
        frameBorder={0}
      />
    </div>
  );
};
